import { ImageWithFallback } from '../ui/ImageWithFallback';

interface PromoTileProps {
  label: string;
  image?: string;
  icon?: React.ReactNode;
  onClick: () => void;
  className?: string;
}

function ArrowIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
    </svg>
  );
}

export function PromoTile({ label, image, icon, onClick, className = '' }: PromoTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group relative rounded-2xl overflow-hidden aspect-[4/5] text-left shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ${className}`}
    >
      <ImageWithFallback src={image} alt={label} className="absolute inset-0 w-full h-full" icon={icon} />
      <div className="absolute inset-0 bg-gradient-to-t from-text-dark/80 via-text-dark/10 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center justify-between">
        <span className="text-white font-bold text-base sm:text-lg">{label}</span>
        <span className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white group-hover:bg-white group-hover:text-chocolate transition-colors">
          <ArrowIcon />
        </span>
      </div>
    </button>
  );
}
